import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7500Model } from "../kymw7500.model";

type GetClassListForCheckPlanNumResponse = {
  ClassDivNum: string;
  ClassCode: string;
  ClassName: string;
}[];

/**
 * 部門コードの選択肢を取得するサービス
 *
 * @export GetClassListForCheckPlanNumService
 * @class GetClassListForCheckPlanNumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetClassListForCheckPlanNumService extends PlessJsonResponderSub<GetClassListForCheckPlanNumResponse> {
  private model: KYMW7500Model;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetClassListForCheckPlanNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetClassListForCheckPlanNumService
   */
  execute(model: KYMW7500Model, successFunc?: () => void) {
    this.model = model;
    this.successFunc = successFunc;
    // KYMW02getClassListを呼び出す
    this.send('KYMW02getClassList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ 
   * @memberof GetClassListForCheckPlanNumService 
   */
  success(data: GetClassListForCheckPlanNumResponse) {
    this.model.classCodeList = [
      // blankを追加
      { code: '', name: '' },
      ...data.map(item => ({
        code: item.ClassCode,
        name: `${item.ClassCode}:${item.ClassName}`
      }))];

    if (!!this.successFunc) {
      this.successFunc();
    }
  }
} 